import { useBrand } from "context/BrandContext";
import { BiSolidGridAlt } from "react-icons/bi";
import { IoMenu } from "react-icons/io5";

interface ViewFilterProps {
	gridView: boolean;
	setGridView: (gridView: boolean) => void;
}

const ViewFilter = ({ gridView, setGridView }: ViewFilterProps) => {
	const { theme } = useBrand();
	const [inactiveViewTypeColor, activeViewTypeColor] = theme.viewTypeColors;

	return (
		<div className="view-filter-view-type">
			<IoMenu
				size={38}
				className="clickable"
				color={gridView ? inactiveViewTypeColor : activeViewTypeColor}
				onClick={() => setGridView(false)}
			/>
			<div className="view-filter-view-type-divider"></div>
			<BiSolidGridAlt
				size={29.5}
				className="clickable"
				color={gridView ? activeViewTypeColor : inactiveViewTypeColor}
				onClick={() => setGridView(true)}
			/>
		</div>
	);
};

export default ViewFilter;
